module.exports = __webpack_public_path__ + "static/s2-68e8b1688fd9898dd83ca81d826fbfd8.jpg";